import { z } from 'zod';
import translations from './../texts';
import { getDefaults } from 'utils/schema/zodUtils';

const enquiryFormSchema = z
  .object({
    name: z.string().default(''),
    companyName: z.string().optional().default(''),
    email: z.string(),
    phoneNumber: z.string().optional(),
    city: z.object({
      id: z.number().default(0),
      name: z.string().default(''),
    }),
    channel: z.string(),
    isProfessional: z.boolean().default(false),
    leadSource: z.string().default('website'),
    source: z.string().optional().default(''),
    iataType: z.string().default('iata'),
    enterIataNumber: z.boolean().default(false),
    iataNumber: z.string().optional().default(''),
    partnerConsortium: z.boolean().optional().default(false),
    partnerConsortiumName: z.string().optional().default(''),
    notes: z.string().optional().default(''),
    referralName: z.string().optional().default(''),
    otherSource: z.string().optional().default(''),
  })
  .superRefine((data, ctx) => {

    if (data.name.length < 1) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['name'],
        message: translations.myler_enquiry_form_name_required,
      });
    }
    if (data.email.length < 1) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['email'],
        message: translations.myler_enquiry_form_valid_email,
      });
    }

    if (data.city && !data.city.name || !data.city.id || data.city.id === 0) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['city.id'],
        message: translations.cityOfResidence_input_error,
      });
    }
    if (data.channel.length < 1) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['channel'],
        message: translations.enquiry_form_channel_input_error,
      });
    }


    if (data.enterIataNumber && !data.iataType) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['iataType'],
        message: 'Please select IATA number type',
      });
    }
    if (data.enterIataNumber && data.iataType && !data.iataNumber) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['iataNumber'],
        message: `Please enter your ${data.iataType.toUpperCase()} number`,
      });
    }
    if (data.partnerConsortium && !data.partnerConsortiumName) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['partnerConsortiumName'],
        message: 'Please enter preferred hotel partner program or consortia',
      });
    }
    if (
      data.channel &&
      data.channel?.split('-')[1].toLowerCase() === 'referral' &&
      !data.referralName
    ) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['referralName'],
        message: 'Please enter the referral name',
      });
    }
  });

export const enquiryFormDefault =
  getDefaults<typeof enquiryFormSchema>(enquiryFormSchema);

type EnquiryFormSchema = z.infer<typeof enquiryFormSchema>;

export { type EnquiryFormSchema, enquiryFormSchema };
